module.exports = __webpack_public_path__ + "img/nor_cha_wulfrik_0.d717b95f.png";